import React from "react";
import styles from "./Row.module.css";
import { translateDate } from "../../../../../../common/providers";
import { CustomTooltip } from "../../../../../../common/components";

const ModelRow = ({ workflow }) => (
	<div className={styles.row}>
		<div className={styles.rowId}>{workflow.id}</div>
		<CustomTooltip showWhenOverflow title={workflow.title}>
			<div className={styles.rowTitle}>{workflow.title}</div>
		</CustomTooltip>
		<CustomTooltip showWhenOverflow title={workflow.description}>
			<div className={styles.rowDescription}>{workflow.description}</div>
		</CustomTooltip>
		<div className={styles.rowCreated}>{translateDate(workflow.created)}</div>
	</div>
);

export default ModelRow;
